import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ScriptManager from './ScriptManager';
import '../pages/Dashboard.css';

const OpinionScriptBuilder = () => {
  const navigate = useNavigate();

  // Check authentication
  useEffect(() => {
    const authenticated = sessionStorage.getItem('opinionServiceAuthenticated');
    if (!authenticated) {
      navigate('/opinion-service-login');
    }
  }, [navigate]);

  return (
    <div className="dashboard-container">
      {/* Back button */}
      <div className="fixed top-4 left-4 z-50">
        <button
          onClick={() => navigate('/opinion-service')}
          className="px-3 py-2 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition text-sm font-medium shadow-md"
        >
          ← Back to Dashboard
        </button>
      </div>

      {/* Main content area matching Dashboard layout */}
      <main className="main-content">
        <div className="main-content-inner main-content-inner--full-bleed">
          <div className="main-content-page">
            <ScriptManager isOpinionService={true} />
          </div>
        </div>
      </main>
    </div>
  );
};

export default OpinionScriptBuilder;
